import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';

const modalWrapperSx = (theme) => ({
  padding: '20px',
  '& h2': {
    ...theme.mixins.marketplaceModalTitleStyles,
  },
});

const modalTextWrapperSx = {
  marginTop: '20px',
  marginBottom: '40px',
  whiteSpace: 'pre-line',
};

const modalButtonWrapperSx = {
  marginTop: '24px',
};

/**
 * Modal component that displays push notifications with a title, message and action button
 *
 * @component
 * @param {object} props
 * @param {object} props.pushNotificationModalData - Data for the notification including title and message
 * @param {boolean} props.pushNotificationModalOpen - Controls whether the modal is displayed
 * @param {Function} props.handlePushNotificationButtonClick - Handler called when notification button is clicked
 * @param {Function} props.onManageDisableScrolling - Handler to manage scroll behavior when modal opens/closes
 * @returns {React.ReactNode} A modal displaying a push notification with action button
 */

const PushNotificationModal = ({
  pushNotificationModalData,
  pushNotificationModalOpen,
  handlePushNotificationButtonClick,
  onManageDisableScrolling,
}) => {
  const handleClick = () => {
    handlePushNotificationButtonClick();
  };

  return (
    <Modal
      id="PushNotificationModal"
      isOpen={pushNotificationModalOpen}
      onClose={handlePushNotificationButtonClick}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Box sx={modalWrapperSx}>
        <FormattedMessage
          id="Page.pushNotification.title"
          tagName="p"
          values={{ title: pushNotificationModalData.title }}
        />
        <Box sx={modalTextWrapperSx}>
          <FormattedMessage
            id="Page.pushNotification.message"
            values={{ message: pushNotificationModalData.message }}
          />
        </Box>
        <Box sx={modalButtonWrapperSx}>
          <Button color="success" onClick={handleClick} variant="contained">
            <FormattedMessage id="Page.pushNotification.buttonText" />
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PushNotificationModal;
